import actions from './actions';
import type { ModalState } from './models';

const initialState: ModalState = {
  open: false,
  modalType: '',
  modalProps: null,
  redirectedFromAnotherService: 'congratulations',
};

const reducer = (state = initialState, action: any): ModalState => {
  switch (action.type) {
    case actions.MODAL_OPEN:
      return {
        ...state,
        open: true,
        modalType: action.modal,
        modalProps: action.modalProps,
      };
    case actions.MODAL_CLOSE:
      return {
        ...state,
        open: false,
      };
    case actions.REDIRECTED_FROM_ANOTHER_SERVICE:
      return {
        ...state,
        redirectedFromAnotherService: action.payload,
      };
    case actions.MODAL_EDIT:
      return {
        ...state,
        open: state.open,
        modalType: state.modalType,
        modalProps: action.modalProps,
      };
    default:
      return state;
  }
};

export default reducer;
